export enum Language {
  English = "en",
  Spanish = "es",
}

export type MultiLanguageString = Record<Language, string>;
